import React from 'react'
import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Currency from 'components/UI/Currency'

export const Wrapper = styled.div`
  background-color: ${colors.light2};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${fonts.libreBaskerville};
  padding: 20px 0;
`

export const Title = styled.div`
  color: ${colors.pink};
  width: 100%;
  text-align: center;
  font-size: 28px;
  margin: 20px 0px;
`

export const Options = styled.div`
  display: flex;
  padding-left: 40px;
`

export const Option = styled.div`
  position: relative;
  background-color: white;
  padding: 30px 70px 50px 70px;
  border-radius: 12px;
  margin-right: 40px;
`

export const Price = styled.div`
  font-size: 45px;
  color: ${colors.darkPurple};
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
`

export const SaveMoneyChip = styled.div`
  position: absolute;
  top: 0;
  right: -20px;
  height: 90px;
  width: 90px;
  border-radius: 50%;
  background-color: ${colors.yellow};
  color: ${colors.pink};
  > div {
    width: 100%;
    text-align: center;
  }
  & div:nth-child(1) {
    margin-top: 20px;
    font-size: 18px;
  }
  & div:nth-child(2) {
    font-weight: bold;
    font-size: 24px;
  }
`

export default props => {
  const { plans } = props
  let savedAmount = plans.filter(p => p.interval === 'month')[0].amount * 12 - plans.filter(p => p.interval === 'year')[0].amount
  return (
    <Wrapper>
      <Title>Select your payment plan</Title>
      <Options>
        {[...plans].sort((a, b) => a.amount - b.amount).map((p, i) => (
          <Option key={i}>
            <Price>
              <Currency
                amount={p.amount / 100}
                currency={p.currency}
              />
            </Price>
            <Button onClick={() => props.onSubmit(p)}>
              {p.interval === 'month' ? 'Monthly' : 'Yearly'}
            </Button>
            {p.interval === 'year' ? (
              <SaveMoneyChip>
                <div>Save</div>
                <div>
                  <Currency amount={savedAmount / 100} currency={p.currency} />
                </div>
              </SaveMoneyChip>
            ) : null}
          </Option>
        ))}
      </Options>
    </Wrapper>
  )
}
